// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAWN from "vue-awesome-notifications"
import moment from 'moment'
import VModal from 'vue-js-modal'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from "@/store"
import VueYouTubeEmbed from 'vue-youtube-embed'
import 'swiper/dist/css/swiper.css'

// Vue.use(VueYouTubeEmbed)
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })
Vue.use(VueAwesomeSwiper)


Vue.use(VModal)
Vue.config.productionTip = false
window.$ = window.jQuery = require('jquery');

Vue.use(VueAWN)
Vue.use(require('vue-pusher'), {
    api_key: 'f4e9d795e6567e65f4a6',
    options: {
        cluster: 'ap1',
        encrypted: true,
    }
});

Pusher.logToConsole = true;

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});


Vue.filter('toVNDate', function (value) {
    var date = new moment(value, "YYYY-MM-DD HH:mm:SS")
    return date.format("DD/MM/YYYY")
});

Vue.filter('weekname', function (value) {
  switch(value) {
      case 0:
          return 'Chủ nhật'
          break;
      case 1:
          return 'Thứ Hai'
          break;

      case 2:
          return 'Thứ Ba'
          break;

      case 3:
          return 'Thứ Tư'
          break;

      case 4:
          return 'Thứ Năm'
          break;

      case 5:
          return 'Thứ Sáu'
          break;

      case 6:
          return 'Thứ Bảy'
          break;
      default:
          return 'Ngày không hợp lệ'
      }
});

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  components: { App},
  store,
  template: '<App/>',
  methods: {
        number2array(lowEnd, highEnd) {
            var list = [];
            for (var i = lowEnd; i <= highEnd; i++) {
                list.push(i);
            }
            return list;
        },
        changeRouteByTime() {
            setInterval(() => {
                var hour = parseInt(moment().format('HH'));
                var minute = parseInt(moment().format('mm'));
                var second = parseInt(moment().format('ss'));
                
                // console.log(second + ' ' + minute + ' ' + hour);

                if (hour == 8 && minute == 0 && second == 0) {
                    this.$router.push({ path: 'home' });
                }
                if (hour == 9 && minute == 0 && second == 0) {
                    this.$root.$emit('at-9AM', 'shoot')
                }

                if (hour == 1 && minute == 0 && second == 0) {
                    this.$root.$emit('at-1AM', 'shoot')
                }
  
                if (hour == 12 && minute == 0 && second == 0) {
                    this.$router.push({ path: 'lunch' });
                }
                              
                if (hour == 12 && minute == 57 && second == 0) {
                    this.$root.$emit('at-1PM', 'shoot')
                    this.$router.push({ name: 'home', query: { start_popup: false }});
                }

                // if( this.number2array(12, 12).indexOf(hour) >= 0 && this.number2array(0, 45).indexOf(minute) >= 0 ) {
                //     this.$router.push({ path: 'lunch' })
                // } else if ( this.number2array(17, 19).indexOf(hour) >= 0 ) {
                //     this.$router.push({ name: 'checkout' })
                // } else if ( this.number2array(20, 23).indexOf(hour) >= 0 || this.number2array(1, 5).indexOf(hour) >= 0 ) {
                //     this.$router.push({ name: 'darkscreen' })
                // } else {
                //     this.$router.push({ name: 'home', query: { start_popup: false }})
                // }
            }, 1000);
        }
    },
    beforeMount(){
        this.changeRouteByTime();
    }
})  



// WEBPACK FOOTER //
// ./src/main.js